import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';


import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'

import ProductActionButton from './productActionButton';

import { getExpense, updateExpense, deleteExpense } from '../../../redux/actions/expenseMasterActions';
import { FEATURES } from '../../utils/constants';

function ProductTable(props) {

    const { getExpense, expenseData, expenseLoading, updateExpense, deleteExpense } = props;

    useEffect(() => {
        let psType = 1
        getExpense(psType)
    }, [getExpense]);


    if (expenseLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Product" LinkName="" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { headerName: 'Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Product Name', field: 'expenseName', tooltipField: 'expenseName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Product/Service Category', field: 'category', tooltipField: 'category', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'GST %', field: 'gst', tooltipField: 'gst', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'TDS %', field: 'tds', tooltipField: 'tds', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true }
        ]

        let frameworkComponents = {
            actionRenderer: ProductActionButton,
        }

        let rowData = []

        expenseData && expenseData.forEach((object, index) => {
            let temp = {}
            temp.code = object.psCode
            temp.psId = object.psId
            temp.HSNCode = Number(object.HSNCode)
            temp.SACCode = Number(object.SACCode)
            temp.expenseName = object.psDescription
            temp.category = object.categoryName
            temp.gst = object.gstPercentage
            temp.tds = ''
            temp.psLineItemGLCode = object.psLineItemGLCode
            temp.description = object.purchaseDesc
            temp.customerNo = object.customerNo
            temp.updateExpense = updateExpense
            temp.deleteExpense = deleteExpense
            temp.customerNo = object.customerNo
            rowData[index] = temp
        })


        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="#"
                    baseUrl={props}
                    hiddenNew={true}
                    newPopup={props.newPopup}
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Product"
                    handleSearch={props.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    expenseData: state.getExpenseData.expense.resultSet,
    expenseLoading: state.getExpenseData.isLoading
    
})

export default connect(mapStatetoProps, { getExpense, updateExpense, deleteExpense })(ProductTable)